import {BenefitType, OrderStatus, ShippingType, SubscriptionStatus} from '../helpers/constants';
import {BenefitHistoryType} from '../helpers/enums';

export class OrdersHistory {
  itemId: number;
  benefitName?: string;
  benefitHistoryType: BenefitHistoryType;
  shippingType: ShippingType;
  benefitType: BenefitType;
  createdOn: Date;
  orderStatus?: OrderStatus;
  subscriptionStatus?: SubscriptionStatus;
  subscriptionActualOrders?: number;
  subscriptionExpectedOrders?: number;
  pictureUrl: string;
  providerName: string;
  isAutoOrderEnabled?: boolean;
  isAutoOrderDynamic?: boolean;
  providerId: number;
  benefitId: number;
  isDeleted: boolean;
  noOfUnits: number;
  price: number;
  shippingTypeLabel?: string;
  benefitTypeLabel?: string;
  orderStatusLabel?: string;
  parsedDate?: string;
  subscriptionStatusLabel?: string;
}
